import { DeleteTwoTone } from "@ant-design/icons";
import { message, Popconfirm } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { deleteRole } from "../../../redux/Roles/actions";

export const DeleteRole = ({ item }) => {
    const dispatch = useDispatch();

    const deleteRole_fun = () => {
        dispatch(deleteRole(item._id));
        message.success("Deleted");
    };

    const confirm = () => {
        deleteRole_fun();
    };

    const cancel = () => {};

    return (
        <Popconfirm
            onConfirm={confirm}
            onCancel={cancel}
            title="Are you sure you want to delete?"
            okText="Yes"
            cancelText="No"
        >
            <DeleteTwoTone twoToneColor="red" key="delete" />
        </Popconfirm>
    );
};

export default DeleteRole;
